import { Component, inject, signal } from '@angular/core';
import { LoginFacade } from '../../../state/login.facade';
import { ConfigService } from '../../../../services/config.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-signup-code',
  templateUrl: './signup-code.component.html',
  styleUrls: ['./signup-code.component.scss']
})
export class SignupCodeComponent {
  private readonly loginFacade = inject(LoginFacade);
  private readonly configService = inject(ConfigService);
  private readonly formBuilder = inject(FormBuilder);

  readonly customMessage = signal(this.configService.get().registrationMessage);

  form: FormGroup = this.formBuilder.group({
    code: ['', Validators.required],
  });

  validateCode(event: Event) {
    event.preventDefault();

    this.loginFacade.validateCode(this.form.get('code').value);
  }

  loadLogin(event: Event) {
    event.preventDefault();
    this.loginFacade.changeScreen('login');
  }
}
